<script>

export default {
  name: 'ImageLoader',
  // props: {
  //   src: {
  //     type: String,
  //     required: true,
  //   },
  // },
  data () {
    return {
      error: false,
      loading: true,
    };
  },
  methods: {
    onLoad () {
      this.loading = false;
      this.error = false;
    },
    onError () {
      this.loading = false;
      this.error = true;
    },
  },
};
</script>

<template lang="pug">
transition(enter-active-class="animated-300 fadeIn", leave-active-class="animated-300 fadeOut")
  img.img-loader(v-bind="$attrs", @load="onLoad", @error="onError", v-show="!loading", v-if="!error")
  slot(name="error", v-if="error")
</template>

<style scoped>

.img-loader {

}

</style>
